import React, { useEffect, useState } from "react"
import Layout from "../components/core/layout/Layout"
import loadComponents from "../config/library-components"
import { componentData } from "./componentData"

export const Head = ({ pageContext }) => {
  const title =
    pageContext.seo?.title ||
    pageContext.pageData.attributes.seo?.title ||
    pageContext.itemData?.attributes.seo?.title

  const description =
    pageContext.seo?.description ||
    pageContext.pageData.attributes.seo?.description ||
    pageContext.itemData?.attributes.seo?.description
  const image =
    pageContext.seo?.image?.data ||
    pageContext.pageData.attributes.seo?.image?.data ||
    pageContext.itemData?.attributes.seo?.image?.data ||
    pageContext.siteData.attributes.defaultSeoImage?.data
  const structuredData =
    pageContext.pageData.attributes.structuredData ||
    pageContext.itemData?.attributes.structuredData

  const canonicalUrl =
    pageContext.seo?.canonicalUrl ||
    pageContext.pageData.attributes.seo?.canonicalUrl ||
    pageContext.itemData?.attributes.seo?.canonicalUrl

  const itemListElement = pageContext.filAriane.map((breadcrumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": breadcrumb.url,
      name: breadcrumb.label,
    },
  }))

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  }

  const [heroImageUrl, setHeroImageUrl] = useState(null)
  useEffect(() => {
    const setHeroImageBasedOnViewport = () => {
      const windowWidth = window.innerWidth
      const heroImageContentInPageData =
        pageContext?.pageData?.attributes?.content?.find(
          (item) => item.__typename === "Strapi_ComponentCommunEnteteHeroImage"
        )

      const heroImageContentInItemData =
        pageContext?.itemData?.attributes?.content?.find(
          (item) => item.__typename === "Strapi_ComponentCommunEnteteHeroImage"
        )

      const heroImageContent =
        heroImageContentInPageData || heroImageContentInItemData

      if (heroImageContent) {
        const imageUrl =
          windowWidth <= 768
            ? heroImageContent?.imageVideo?.image?.data?.attributes.formats.L
                .url || null
            : heroImageContent?.imageVideo?.image?.data?.attributes.formats.XL
                .url || null

        setHeroImageUrl(imageUrl)
      }
    }

    setHeroImageBasedOnViewport()

    const handleResize = () => {
      setHeroImageBasedOnViewport()
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [pageContext?.pageData?.attributes?.content])

  return (
    <>
      <link
        rel="icon"
        href="/favicon.ico"
        sizes="any"
      />
      <link
        rel="icon"
        href="/favicon.svg"
        type="image/svg+xml"
      />
      {canonicalUrl && (
        <link
          rel="canonical"
          href={canonicalUrl}
        />
      )}
      {title && (
        <>
          <title>{title}</title>
          <meta
            property="og:title"
            content={title}
          />
        </>
      )}
      {description && (
        <>
          <meta
            name="description"
            content={description}
          />
          <meta
            property="og:description"
            content={description}
          />
        </>
      )}

      {image?.attributes?.formats?.OG?.url && (
        <>
          <meta
            property="og:image"
            content={image.attributes.formats.OG.url}
          />
        </>
      )}
      {heroImageUrl && (
        <link
          rel="preload"
          as="image"
          href={heroImageUrl}
        />
      )}

      {structuredData && (
        <script type="application/ld+json">
          {typeof structuredData === "string"
            ? structuredData
            : JSON.stringify(structuredData)}
        </script>
      )}
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
    </>
  )
}

const SimplePageTemplate = ({ location, pageContext }) => {
  const pageDataAttr = pageContext.pageData.attributes
  const cp = componentData(pageDataAttr, pageContext)

  const components = loadComponents(cp, pageContext, location)

  return pageDataAttr.showHeaderFooter !== false &&
    pageDataAttr.iterable !== "Pop_in" ? (
    <Layout
      pageContext={pageContext}
      siteData={pageContext.siteData}
      sectorsData={pageContext.sectorsData}
      jobAdsData={pageContext.jobAdsData}
      productCategoriesTree={pageContext.productCategoriesTree}
      gcProductCategoriesTree={pageContext.gcProductCategoriesTree}
    >
      {components}
    </Layout>
  ) : (
    <>{components}</>
  )
}

export default SimplePageTemplate
